module.exports = __webpack_public_path__ + "static/osaka-6-3d9f777cfb49a3916bb3c72db0a5d678.jpg";